/**
 * Formula Calendar brand mark
 * Concept: Bold "FC" monogram with an integrated calendar grid accent.
 * Red accent conveys motorsport heritage.
 */

export default function WCLogo({ compact = false }: { compact?: boolean }) {
  return (
    <a
      href="/"
      onClick={(e) => { e.preventDefault(); window.location.href = "/"; window.scrollTo(0, 0); }}
      className="flex items-center gap-2 group cursor-pointer"
      aria-label="Formula Calendar home"
    >
      {/* Mark — FC monogram with calendar notch */}
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
      >
        {/* Background rounded square */}
        <rect x="0.5" y="0.5" width="35" height="35" rx="8" fill="hsl(220 15% 9%)" stroke="hsl(3 85% 48% / 0.3)" strokeWidth="1"/>
        {/* Calendar binding pins */}
        <rect x="10" y="1" width="2.5" height="6" rx="1.25" fill="hsl(3 85% 48%)" />
        <rect x="23.5" y="1" width="2.5" height="6" rx="1.25" fill="hsl(3 85% 48%)" />
        {/* Calendar header bar */}
        <rect x="3" y="5" width="30" height="8" rx="3" fill="hsl(3 85% 48% / 0.12)" />
        {/* FC letter — bold */}
        <text
          x="18"
          y="28"
          textAnchor="middle"
          fill="hsl(3 85% 55%)"
          fontFamily="'Barlow Condensed', 'Arial Narrow', sans-serif"
          fontWeight="800"
          fontSize="18"
          letterSpacing="-0.5"
        >
          FC
        </text>
        {/* Live dot */}
        <circle cx="30" cy="8" r="2.5" fill="hsl(145 60% 45%)" className="live-pulse" />
      </svg>

      {/* Wordmark */}
      {!compact && (
        <div className="flex flex-col leading-none gap-0.5">
          <div className="flex items-baseline gap-1">
            <span
              className="text-[17px] font-extrabold uppercase tracking-tight text-foreground group-hover:text-primary transition-colors"
              style={{ fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: "0.02em" }}
            >
              Formula
            </span>
            <span
              className="text-[17px] font-semibold uppercase tracking-tight text-muted-foreground"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              Calendar
            </span>
          </div>
          <span className="text-[9px] text-primary/70 uppercase tracking-[0.15em] font-semibold">
            F1 · F2 · F3 · FE · IndyCar
          </span>
        </div>
      )}
    </a>
  );
}
